module.exports = __webpack_public_path__ + "static/media/sidebar-img1.72136760.jpg";